import type { PolygonClosedContour } from '../polygon-closed-contour';
import type { PointArray } from '../types/contour-definition-array-type';

import { getClosestPointIdx } from './getClosestPointIdx';
import { interpolateGridPoints2D } from './interpolatePolygonToGrid';
import { snapPolyLineToSubPixelGrid } from './snapPolyLineToSubPixelGrid';

export function createSaxMyocardialPolygon(
  endoContour: PolygonClosedContour,
  epiContour: PolygonClosedContour,
): PointArray {
  const endo = endoContour.getPolygon();
  const epi = epiContour.getPolygon();

  // start with epi
  let fusion = epi;

  // get the point on endo to start
  const startIdxEndo = getClosestPointIdx(epi[epi.length - 1], endo);

  // create connection line
  let connectionLine = [];
  connectionLine.push(epi[epi.length - 1]);
  connectionLine.push(endo[startIdxEndo]);
  connectionLine = interpolateGridPoints2D(connectionLine, 1);
  connectionLine = snapPolyLineToSubPixelGrid(connectionLine, false);

  fusion = fusion.concat(connectionLine);

  // which direction to go
  const direction
    = endoContour.getAreaSigned() * epiContour.getAreaSigned() < 0 ? 1 : -1;

  for (
    let i = startIdxEndo + 1 * direction;
    i !== startIdxEndo;
    i = (i + direction + endo.length) % endo.length
  ) {
    fusion.push(endo[i]);
  }
  // add reversed connection line
  for (let i = connectionLine.length - 1; i >= 0; --i) {
    fusion.push({ x: connectionLine[i].x, y: connectionLine[i].y });
  }
  // close
  fusion.push(fusion[0]);

  return fusion;
}
